import React, { useEffect, useState } from "react";
import "./styles.scss";
import { truncateSentence } from "../../../../../../api/helper";
import linkPreviewImage from "./../../../../../../public/default-link-preview.png";
import HuddleLogo from "./../../../../../../public/logo_without_background.png";
import axios from "axios";

export default ({ link_preview = null, url = null, useDefault = false }) => {
  const [data, setData] = useState(link_preview || {});
  useEffect(() => {
    if (url && process.env.REACT_APP_LINK_PREVIEW_URL) {
      axios
        .post(process.env.REACT_APP_LINK_PREVIEW_URL, { url }, { headers: { Authorization: `Bearer ${process.env.REACT_APP_LINK_PREVIEW_KEY}` } })
        .then(({ data }) => data)
        .then(setData);
    }
  }, [link_preview, url]);
  const video =
    (data.og_video_secure_url && data.og_video_secure_url[0]) ||
    (data.og_video_secure && data.og_video_secure[0]) ||
    (data.og_video_url && data.og_video_url[0]) ||
    (data.og_videos && data.og_videos[0]) ||
    (data.og_video && data.og_video[0]);
  const type = (data.og_type && data.og_type[0]) || data.type;
  const myUrl = (data.og_url && data.og_url[0]) || data.html_url || data.url;
  let image =
    (data.og_image && data.og_image[0]) ||
    (data.twitter_image && data.twitter_image[0]) ||
    (data.twitter_image_src && data.twitter_image_src[0]) ||
    (data.images && data.images[0] && data.images[0].table && data.images[0].table.url) ||
    data.html_image;
  if (!image) {
    if (myUrl && (myUrl.includes("hudlmusic.com") || myUrl.includes("unifimusic.ai"))) {
      image = HuddleLogo;
    } else {
      image = linkPreviewImage;
    }
  }
  const title = (data.og_title && data.og_title[0]) || data.html_title || data.title;
  const default_description =
    "UNIFI Music is where fiercely independent artists and musicians come together to connect, collab, and create. Learn more and register free today at unifimusic.ai.";
  const description = (data.og_description && data.og_description[0]) || data.html_description || data.description;
  const siteName = data.og_site_name && data.og_site_name[0];
  const isMusic = type && type.startsWith("music");
  let spotify_data_link = null;

  if (isMusic) {
    if (siteName === "Spotify") {
      const target = "https://open.spotify.com/";
      spotify_data_link = myUrl.replace(target, "").split("/");
    }
  }

  //Hint: I intentionally checked for spotify because in the future the soundcloud and other sites may need another handle configuration
  //for now they asked us to show spotify as music link

  return Object.keys(data).length > 0 ? (
    (type && type.startsWith("video") && video) || (isMusic && siteName === "Spotify") ? (
      <div className="my-3 embed-responsive embed-responsive-16by9">
        {video ? (
          <iframe id="iframe" className="embed-responsive-item" title="link-preview-videos" src={video}></iframe>
        ) : (
          <div className="spotify-embed-block">
            <iframe
              id="iframe"
              src={`https://open.spotify.com/embed?uri=spotify:${spotify_data_link[0]}:${spotify_data_link[1]}&theme=white`}
              frameBorder="0"
              allowtransparency="true"
            ></iframe>
          </div>
        )}
      </div>
    ) : (
      <a className="my-3 preview-link-preview media" href={myUrl} target="_blank" rel="noopener noreferrer">
        {/* {image && <div className="img" style={{ backgroundImage: `url(${image})` }} />} */}
        <img style={{ objectFit: "cover" }} src={image} alt="" />
        <div className="media-body p-3">
          <p className="link-preview-url text-muted mb-1">{myUrl}</p>
          <h5 className="text-dark">{title}</h5>
          <p className="link-preview-description text-muted">{truncateSentence(description, 230)}</p>
        </div>
      </a>
    )
  ) : (
    <></>
  );
};
